// extracted by mini-css-extract-plugin
module.exports = {"booksBtn":"BooksBtn_booksBtn__6xAtw"};